import { httpV2 } from "@/api";

/**
 * @summary Solicita todos os fabricantes de rolamentos.
 * @returns Conjunto de fabricante.
 */
const GetManufacturers = function()
{
	return httpV2.get("KnowledgeBase/BearingManufacturers");
};

/**
 * @summary Solicita os modelos de rolamentos de um fabricante.
 * @param {number} bearingManufacturerId Id do fabricante.
 * @returns Conjunto de modelos de rolamentos do fabricante.
 */
const GetModels = function(bearingManufacturerId)
{
	return httpV2.get(`KnowledgeBase/BearingManufacturers/${bearingManufacturerId}/Models`);
};

export default {
	GetManufacturers,
	GetModels,
};